import { useContext, useState } from "react";
import Inputs from "../../../../../global/component/Genericos/Inputs/Inputs";
import TextArea from "../../../../../global/component/Genericos/TextArea/TextArea";
import { showToaster } from "../../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../../global/context/Provider";
import { regexNombre, regexNumero } from "../../../../../global/utils/expresionesRegulares";
import FlechaDropdown from "../../../../assets/images/generico/FlechaDropdown";
import { Container, HeaderModal, Modal, Title } from "../../../../../global/styled/libraries/modalAbm/modalAbm";

const AbmAutoCheckIn = ({
    setType, 
    type, 
    form, 
    submitFomPut, 
    submitFormCreate
}) => {

    const {
        toasterState,
        toasterDispatch
    } = useContext(GlobalContext);


     // cerrar el modal
     const handleClose = () => {
        setType(false)
    }

    const initialState = {
        id: -1,
        idtipotexto: 20,
        idtipotexto_desc: "Auto Check In",
        nombre: "",
        descripcion: "",
        idasociado: -1,
        orden: -1,
        table: "", 
    }
    // fromulario local 
    const [localForm, setLocalForm] = useState(type === "PUT"? form: initialState);

    // formulario de required 
    const [stateRequired, setStateRequired] = useState({
        nombre: false, 
        descripcion: false
    })



    const handleUpdate = () => {
        if(localForm.nombre !== "" && localForm.descripcion !== ""){
            submitFomPut(localForm);
            
        }else {
            showToaster(
                {
                  texto: "Complete todos los campos requeridos",
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
        }
    };

     // Crear y editar
     const handleCreate = () => {
        if(localForm.nombre !== "" && localForm.descripcion !== ""){
          
            setStateRequired({
                ...stateRequired,
                nombre: false, 
                descripcion: false, 
            });
            submitFormCreate(localForm);
        }else {
            setStateRequired({
                ...stateRequired,
                nombre: localForm.nombre !== "" ? false: true, 
                descripcion: localForm.descripcion !== ""? false: true,                 
            });

            showToaster(
                {
                  texto: "Complete todos los campos requeridos",
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
        }
    };

    return (
        <Container>
            <div onClick={handleClose} className="fondo-abm"/>
            <Modal>
                <HeaderModal>
                    <Title>{type ==="POST"? "Crear un registro nuevo": "Editar un registro"}</Title>
                    <div className={"ptur-flechitaAbm"}> <FlechaDropdown  color="var(--color-latex10)" height={"35"} width={"35"} /></div>
                    <div onClick={handleClose} className="cruz-modalAbm-x">X</div>
                </HeaderModal>
                <Inputs
                        property="nombre"
                        placeholder="Ingrese el nombre"
                        regex={regexNombre}
                        errorStr="Debe ser una palabra"
                        headerStr="Nombre"
                        state= {localForm}
                        setState= {setLocalForm}
                        isRequired = {true}
                        value= {type === "PUT" ?form.nombre: false}
                        extraProperty={{
                            initialValue: "", 
                            errorForced: stateRequired.nombre, 
                            setErrorForced: setStateRequired, 
                            stateRequired: stateRequired
                        }}
                        />        
                    
                    <TextArea 
                         property="descripcion"
                         placeholder="Ingrese el texto la descripcion"
                         regex={/[a-zA-Z]+/}  
                         errorStr="Esta equivocado"
                         headerStr="Descripción"
                         state= {localForm}
                         setState= {setLocalForm}
                         isRequired = {true}
                         value= {type === "PUT" ?form.descripcion: false}
                         extraProperty={{
                            initialValue: "", 
                            cantMaxText: 1000,
                            heightForced: "100px",
                            errorForced: stateRequired.descripcion, 
                            setErrorForced: setStateRequired, 
                            stateRequired: stateRequired
                         }}
                        />
                    {
                        type === "POST"?  <button className="button" onClick={handleCreate}>Crear</button>:
                        <button className="button" onClick={handleUpdate}>Editar</button>
                    }
            </Modal>
        </Container>
    )
}

export default AbmAutoCheckIn; 